export const CHART_YEAR_COLORS = [
  'teal',
  'blue',
  'grape',
  'orange',
  'cyan',
  'pink',
  'lime',
  'indigo',
  'yellow',
  'red',
];

export function yearColor(index) {
  return CHART_YEAR_COLORS[index % CHART_YEAR_COLORS.length];
}
